import styles from "./FeatureItem/FeatureItem.module.css";
import stylesUpvote from "./FeatureItem/FeatureUpvote/FeatureUpvote.module.css";
import stylesInfo from "./FeatureItem/FeatureInfo/FeatureInfo.module.css";
import { Skeleton } from "@mui/material";

import React from "react";

export default function FeatureSkeleton() {
	return (
		<>
			<hr className={styles.hr} />
			<div className={styles.item}>
				<Skeleton height={"80px"} className={stylesUpvote.upvoteToggle} sx={{ border: "none" }} />
				<div className={stylesInfo.container}>
					<Skeleton className={stylesInfo.header} width={"20vw"} />
					<Skeleton className={stylesInfo.description} width={"60vw"} />
					<Skeleton className={stylesInfo.dateAndModule} width={"15vw"} />
				</div>
			</div>
		</>
	);
}
